<template>
  <v-row justify="center">
    <v-dialog v-model="activate" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Přidat odběratele</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    :label="$t('forms.company')"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="ico" :label="$t('forms.ic')" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="dic" :label="$t('forms.dic')"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    :label="$t('forms.email')"
                    append-icon="mdi-email-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="person" :label="$t('forms.contactPerson')"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="phone" :label="$t('forms.phone')"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="address" :label="$t('forms.address')"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field v-model="city" :label="$t('forms.city')"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field v-model="zip" :label="$t('forms.zip')"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field v-model="state" :label="$t('forms.state')"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="businessField"
                    :items="items"
                    :label="$t('forms.business')"
                    multiple
                    item-text="text"
                    item-value="type"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="remove(data.item)"
                      >{{ data.item.text }}</v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Close</v-btn>
          <v-btn color="blue darken-1" text @click="validate">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar.visible" :timeout="3000">
      <v-icon>mdi-check</v-icon>

      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-row>
</template>

<script>
import gql from "graphql-tag";
export default {
  props: ["activate"],
  data() {
    return {
      snackbar: {
        visible: false,
        message: "",
        icon: "mdi-check",
      },
      valid: true,
      name: null,
      nameRules: [],
      ico: null,
      dic: null,
      email: null,
      emailRules: [],
      person: null,
      phone: null,
      address: null,
      city: null,
      zip: null,
      state: null,
      businessField: [],

      items: [
        { type: "distributor", text: "Distributor"},
        { type: "hospital", text: "Nemocnice"},
        { type: "veterine", text: "Veterinář"},
        { type: "technic", text: "Technika"},
      ],
    };
  },
  methods: {
    validate() {
      this.$refs.form.validate();
      if (this.valid) {
        this.$apollo
          .mutate({
            // Query
            mutation: gql`
              mutation(
                $name: String!
                $ico: String
                $dic: String
                $email: [String]
                $person: [String]
                $phone: [String]
                $address: String
                $city: String
                $zip: String
                $state: String
                $businessField: [String]
              ) {
                createCustomer(
                  companyInput: {
                    name: $name
                    ico: $ico
                    dic: $dic
                    email: $email
                    person: $person
                    phone: $phone
                    address: $address
                    city: $city
                    zip: $zip
                    state: $state
                    businessField: $businessField
                  }
                ) {
                  name
                }
              }
            `,
            variables: {
              name: this.name,
              ico: this.ico,
              dic: this.dic,
              email: this.email ? [this.email] : [],
              person: this.person ? [this.person] : [],
              phone: this.phone ? [this.phone] : [],
              address: this.address,
              city: this.city,
              zip: this.zip,
              state: this.state,
              businessField: this.businessField,
            },
          })
          .then(() => {
            this.qlDone(true);
          })
          .catch(() => {
            this.qlDone(false);
          });
      }
    },
    qlDone(success) {
      if (success) {
        this.snackbar = {
          visible: true,
          message: "Dodavatel uložen",
          icon: "mdi-check",
        };
        setTimeout(() => {
          this.close()
        }, 500);
      } else {
        this.snackbar = {
          visible: true,
          message: "Chyba",
          icon: "mdi-alert-circle",
        };
      }
    },
    close() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$emit("close-dialog", false);
    },
    remove(item) {
      const index = this.businessField.indexOf(item.text);
      if (index >= 0) this.businessField.splice(index, 1);
    },
  },
  mounted() {
    this.nameRules = [
      (v) => !!v || this.$t("forms.nameRequired"),
      (v) => (v && v.length <= 50) || this.$t("forms.nameMax"),
      (v) => (v && v.length > 2) || this.$t("forms.nameMin"),
    ];
    /*
    this.emailRules = [
      (v) => !!v || this.$t("forms.emailRequired"),
      (v) => /.+@.+\..+/.test(v) || this.$t("forms.emailValid"),
    ];
    */
  },
};
</script>